const config = require("../config")
const url = config.base_dev_url + "z_agricultural_store"

module.exports = {
    service_price: {
        url: url + "/service_price",
        type: "get",
    },
    updatePrice: {
        url: url + "/service_price/update",
        type: "post",
    },
    statistics: {
        url: url + "/statistics",
        type: "get",
    },
    updateService: {
        url: url + "/update",
        type: "post",
    },
    getServiceDetail: {
        url: url + "/detail",
        type: "get",
    },
    getStoreDetail: {
        url: url + "/detail",
        type: "get",
    },
    getStoreList: {
        url: url + "_farm" + "/list",
        type: "get",
    },
    getStoreItem: {
        url: url + "_farm" + "/get_agricultural_store_by_farm_id",
        type: "get",
    },
}